import { debounce } from 'lodash-es'
import { useDefaultModal } from './defaultModal'
import DeleteAccount from '@/features/account/delete/index.vue'
import type { DELETE_TYPE } from '~/utils/constant'

export const showDeleteAccount = debounce(
  (logout: () => void, type: DELETE_TYPE) => {
    const { $t } = useNuxtApp()

    const cancel = () => {
      modal.destroy()
    }

    const modal = useDefaultModal({
      title:
        type === 'team'
          ? $t('tuan-dui-zhang-hao-zhu-xiao-feng-xian')
          : $t('zhang-hao-zhu-xiao-feng-xian'),
      width: 656,
      center: true,
      content: [
        // <CloseOutlined class={CloseIconOutClass} onClick={cancel} />,
        <DeleteAccount type={type} cancel={cancel} logout={logout} />,
      ],
      wrapClassName: 'delete-account-modal',
      footer: false,
    })

    return modal
  },
  200
)
